import React from "react";
import styled, { useTheme } from "styled-components";
import { Box } from "../Box";
import { Text } from "../Text";
const StyledBox = styled(Box)(({ theme: { colors: { searchBoxColors }, }, }) => ({
    background: searchBoxColors.hintBackground,
    borderRadius: "0px 0px 4px 4px",
    color: searchBoxColors.hintText,
    margin: 0,
    padding: "5px 10px",
}));
const FacetPill = styled.div(({ theme: { colors: { searchBoxColors }, borders, fontSizes, }, }) => ({
    background: searchBoxColors.facetPillBackground,
    border: borders[1],
    borderColor: searchBoxColors.facetPillBorder,
    borderRadius: "3px",
    color: searchBoxColors.facetPillText,
    display: "inline-block",
    fontSize: fontSizes[0],
    margin: "2px",
    padding: "0px 2px",
}));
export const SearchDropdownHint = ({ children, facets }) => {
    const { colors: { searchBoxColors }, } = useTheme();
    return (React.createElement(StyledBox, { "data-testid": "dropdownHint" },
        children,
        React.createElement(Box, null, facets.map((facet, index) => (React.createElement(Text, { color: searchBoxColors.hintText, key: facet.id },
            index !== 0 && ", ",
            React.createElement(FacetPill, null, `${facet.name}:`)))))));
};
export const DefaultSearchDropdownFacetHint = ({ facets, facetsMessageFirstHalf, facetsMessageSecondHalf, }) => {
    const { colors: { searchBoxColors }, } = useTheme();
    return (React.createElement(SearchDropdownHint, { facets: facets },
        React.createElement(Text, { color: searchBoxColors.hintText },
            facetsMessageFirstHalf,
            React.createElement(FacetPill, { style: { marginLeft: "4px", marginRight: "4px" } }, "?"),
            facetsMessageSecondHalf)));
};
const NoResultsStyledBox = styled(Box)({
    padding: "7px 12px",
});
export const DefaultNoResultsHint = ({ noMatchesFoundMessage }) => (React.createElement(NoResultsStyledBox, { "data-testid": "noMatchesFound" }, noMatchesFoundMessage));
